import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { defaultLanguage, useCourseContext } from 'context';

const getSafeHttpUrl = (value?: string | null): string | undefined => {
  if (!value) return undefined;

  try {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol) ? value : undefined;
  } catch {
    return undefined;
  }
};

export const useCourseCompletionButtonData = () => {
  const { course, language } = useCourseContext();
  const { t } = useTranslation(['course']);

  return useMemo(() => {
    let buttonTitle = course?.courseCompletionButtonTitle;

    if (language !== defaultLanguage) {
      const localizedButtonTitle =
        course?.translations?.[language]?.courseCompletionButtonTitle;

      if (localizedButtonTitle) {
        buttonTitle = localizedButtonTitle;
      }
    }

    return {
      buttonTitle: buttonTitle?.trim() || t('goToMCIRLMS'),
      buttonUrl: getSafeHttpUrl(course?.courseCompletionButtonUrl),
    };
  }, [course, language, t]);
};
